// extracted by mini-css-extract-plugin
export default {"turboIcon":"DLP8PNBNPISjtRnJui6PIA==","turboIconImage":"q8B4hXEmosGyppt5KscL3Q==","turboIconText":"Kf1Xb82O6z7edDoRbU8ocA=="};